module.exports = __webpack_public_path__ + "static/media/download-Button.83829cfa.svg";